<template>
    <a
        href="#"
        style="text-decoration: underline;"
        @click="handleNameClick"
    >
        <span v-html="airbnbPropertyName" :class="{ 'custom-property-name': this.feedShare.custom_property_name !== null }"></span>
    </a>
</template>

<script>
import { escapeHTML } from '../../../utils/strings';

export default {
    data() {
        return {
            feedShare: null,
        };
    },
    computed: {
        airbnbPropertyName() {
            let name = '';
            
            if (this.feedShare.custom_property_name !== null)
            {
                name = escapeHTML(this.feedShare.custom_property_name);
            }
            else {
                name = escapeHTML(this.feedShare.rental_property.name);
                if (this.feedShare.use_marketing_title) {
                    name = escapeHTML(this.feedShare.rental_property.marketing_title);
                }
            }
            return name;    
        },
    },
    created() {
        this.feedShare = this.params.data;
    },
    methods: {
        handleNameClick() {
            this.params.handleNameClick && this.params.handleNameClick(this.feedShare, this.airbnbPropertyName);
        },
    },
    watch: {
        params(value) {
            this.feedShare = value.data;
        },
    },    
};
</script>


<style lang="scss" scoped>
    :deep(.custom-property-name) {
        font-weight: bold;
    }

</style>